<app-header 
  [icon]="'arrow_back_ios'"
  (iconClickedEvent)="back()">
</app-header>

<div class="container">
  <div class="sub-title">
    {{ 'list-patients.title' | translate }}
  </div>
@for (item of patients(); track item.id) {
    <div class="item-container">
      <div class="info">
        <div class="row">
          <mat-icon>person</mat-icon>
          <span class="name">{{item.first_name + ' ' + item.last_name}}</span>
        </div>
        <div class="row">
          <mat-icon>mail</mat-icon>
          <span>{{item.email}}</span>
        </div>
        @if (item.phone_number) {
          <div class="row">
            <mat-icon>phone</mat-icon>
            <span>{{ item.phone_number | phoneNumber }}</span>
          </div>
        }        
      </div>
      @if (item.phone_number) {
        <div class="contact">
          <a [href]="'https://wa.me/' + $safeNavigationMigration(item?.phone_number)"><img class="wapp-icon" src="/imgs/wapp_logo.png" alt="icon from whatsapp"></a>
        </div>
      }         
    </div>
}
</div>
